import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const StoreFrontIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g clipPath="url(#clip0_6393_2936)">
            <path
              d="M21.901 8.89L20.8507 4.52C20.6306 3.62 19.8504 3 18.9401 3H5.04562C4.14533 3 3.35507 3.63 3.145 4.52L2.09467 8.89C1.85459 9.91 2.07466 10.95 2.71487 11.77C2.79489 11.88 2.90493 11.96 2.99496 12.06V19C2.99496 20.1 3.89525 21 4.9956 21H19.0001C20.1005 21 21.0007 20.1 21.0007 19V12.06C21.0908 11.97 21.2008 11.88 21.2808 11.78C21.921 10.96 22.1511 9.91 21.901 8.89ZM18.9101 4.99L19.9604 9.36C20.0604 9.78 19.9704 10.2 19.7103 10.53C19.5703 10.71 19.2702 11 18.77 11C18.1598 11 17.6297 10.51 17.5596 9.86L16.9795 5L18.9101 4.99ZM12.9982 5H14.9588L15.499 9.52C15.549 9.91 15.429 10.3 15.1689 10.59C14.9488 10.85 14.6287 11 14.2186 11C13.5484 11 12.9982 10.41 12.9982 9.69V5ZM8.48672 9.52L9.0369 5H10.9975V9.69C10.9975 10.41 10.4474 11 9.70712 11C9.36701 11 9.05691 10.85 8.81683 10.59C8.56675 10.3 8.44671 9.91 8.48672 9.52ZM4.03529 9.36L5.04562 5H7.01625L6.43606 9.86C6.35604 10.51 5.83587 11 5.22567 11C4.73552 11 4.42542 10.71 4.29537 10.53C4.02529 10.21 3.93526 9.78 4.03529 9.36ZM4.9956 19V12.97C5.07563 12.98 5.14565 13 5.22567 13C6.09595 13 6.88621 12.64 7.46639 12.05C8.06659 12.65 8.86684 13 9.77714 13C10.6474 13 11.4277 12.64 12.0079 12.07C12.598 12.64 13.3983 13 14.2986 13C15.1389 13 15.9391 12.65 16.5393 12.05C17.1195 12.64 17.9098 13 18.78 13C18.8601 13 18.9301 12.98 19.0101 12.97V19H4.9956Z"
              fill="#222"
            />
          </g>
          <defs>
            <clipPath id="clip0_6393_2936">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
